export const USA_ID = -1
export const CANADA_ID = 393
export const AUSTRALIA_ID = 290

export const countriesWithState = [USA_ID]
